import type { User } from '@auth0/auth0-react';

export const ROLES_CLAIM = 'https://app.creditpulse.com/roles';

export const getUserRoles = (user: User | undefined): string[] => {
  const roles = user?.[ROLES_CLAIM];
  return Array.isArray(roles) ? roles : [];
};

export const isSuperAdmin = (user: User | undefined): boolean =>
  getUserRoles(user).includes('SUPER_ADMIN');

export const isOrgAdmin = (user: User | undefined): boolean =>
  getUserRoles(user).includes('ORG_ADMIN');

export const hasRole = (user: User | undefined, role: string): boolean =>
  getUserRoles(user).includes(role);
